import  { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./style.scss";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  Label,
  Row,
  Col,
} from "reactstrap";
import FileSaver from "file-saver";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { CalenderIcon } from "../../components/Icon";
import { NewDownloadIconActive } from "../../assets/images";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { downloadPhysicalVerificationReportApi } from "../../apis/fixedAssetRegisterApi";
type sortByType = {
  name: string;
  value: string;
};

type AppProps = {
  token?: string | null;
  filterConditionData: any;
  client_code: number | null;
  searchValue: string;
  selectDepartment: any;
  sortByOldest: sortByType;
  sortByLocation: sortByType;
  sortByDeparment: sortByType;
  company_name:string;
};

const PhysicalVerificationDownloadReport = ({
  token,
  filterConditionData,
  client_code,
  searchValue,
  selectDepartment,
  sortByOldest,
  sortByLocation,
  sortByDeparment,
  company_name
}: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownButtonRef = useRef<HTMLDivElement>(null);
  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleOutsideClick = (event:any) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdownButtonRef.current &&
        !dropdownButtonRef.current.contains(event.target)
      ) {
        setStartDate(null);
        setEndDate(null);
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [dropdownRef]);

  const handleStartDate = (date: any) => {
    setStartDate(date);
    setEndDate(null);
  };

  const handleDownload = () => {
    setShowDropdown(false);
    handlePrepareReportData();
  };
  const handlePrepareReportData = () => {
    const trueKeys: string[] = Object.keys(filterConditionData).filter(
      (key) => filterConditionData[key] === true
    );

    const resultString = trueKeys.join(",");

    let params: any = {
      client_code,
      condition: resultString,
      is_verified: 1,
      department: selectDepartment?.value ? selectDepartment?.value : "",
      sort_by: sortByLocation?.name
        ? "location"
        : sortByDeparment?.name
        ? "department"
        : sortByOldest?.name
        ? "updated_at"
        : "",
      sort_by_value: sortByLocation?.value
        ? sortByLocation?.value
        : sortByDeparment?.value
        ? sortByDeparment?.value
        : sortByOldest?.value
        ? sortByOldest?.value
        : "",
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      token,
      search_term: searchValue,
    };

    if (params && token) {
      handleDownloadReport(params);
    }
  };
  const handleDownloadReport = (params: any) => {
    let reportName = `PV_${company_name}_${moment(startDate).format("DD-MM-YYYY")}_${ moment(endDate).format("DD-MM-YYYY")}.xlsx`;

    downloadPhysicalVerificationReportApi(params)
      .then((response: any) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
        });
        FileSaver.saveAs(blob, reportName);
        toast.success("Report Downloaded Successfully!", {
          duration: 3000,
        });
        setStartDate(null);
        setEndDate(null);
      })
      .catch((error: any) => {
        toast.success(error, {
          duration: 3000,
        });
      });
  };

  return (
    <>
    <div ref={dropdownRef}>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        // style={showDropdown ? {
        //   color: "#dd4433",
        //   backgroundColor: "#fff6f5",
        // } : {}}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Download Reports
            </Tooltip>
          }
        >
          <DropdownToggle
            caret
            outline
            innerRef={dropdownButtonRef}
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                    padding: "1px 8px 3px 3px",
                  }
                : {
                    border: "1px solid #dd4433",
                    padding: "1px 8px 3px 3px",
                    background: "#fff",
                  }
            }
          >
            <span
              style={{ color: "#dd4433", fontSize: "12px" }}
              onClick={toggleShowDropdown}
              className={`custom-download-btn d-inline-block pointer ${
                showDropdown ? "active" : ""
              }`}
            >
              <img
                src={
                  showDropdown ? NewDownloadIconActive : NewDownloadIconActive
                }
                alt="download icon"
                style={{ marginRight: "5px", width: "20%" }}
              />
              <span style={{ color: "#dd4433" }}>Download</span>
            </span>
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="download-dd p-3">
            <h4>Download Report</h4>
            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>
                  <Col md="6" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={(date: any) => setEndDate(date)}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={startDate && endDate ? false : true}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      <Toaster />
      </div>
    </>
  );
};

export default PhysicalVerificationDownloadReport;
